export const validationMessages = {
  mortgageExpense:
    'Ah, that didn’t work. Enter your monthly mortgage or rent payment, using numbers only, then try again.',
  grossAnnualIncome:
    'Ah, that didn’t work. Enter your annual income, using numbers only, then try again.',
  netMonthlyIncome:
    'Ah, that didn’t work. Let us know how much goes into your account using numbers only. Just a heads up – your household income must be greater than or equal to your annual income.',
  financialCircumstances:
    'Hmm, looks like we’re missing something. Can you let us know if your income is likely to go down then try again?',
  earnIncome:
    'Ah, that didn’t work. Enter how much you’ll earn a year, using numbers only, then try again.'
};
